import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { useDayRender } from 'hooks/useDayRender';
import { Button } from '../Button';
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */
export function Day(props) {
    var buttonRef = useRef(null);
    var dayRender = useDayRender(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) {
        return _jsx("div", { role: "gridcell" });
    }
    if (!dayRender.isButton) {
        return _jsx("div", __assign({}, dayRender.divProps));
    }
    return _jsx(Button, __assign({ name: "day", ref: buttonRef }, dayRender.buttonProps));
}
//# sourceMappingURL=Day.js.map